import { useEffect, useState } from "react";
import RoundInfoItem from "../RoundInfoItem2/RoundInfoItem";
import styles from "./RoundGrid.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
//import SwiperCore, { Autoplay, Pagination, Navigation, FreeMode } from "swiper";

const RoundGrid = ({ title, subtitle, items, more, less, contactsLabel, tier, locked_phrase }) => {
  const [list, setList] = useState([])

  console.log('ITEMS', items);

  useEffect(() => {
    if (items && items.length > 0) {
      setList(items.map((e, i) => (
        <SwiperSlide key={i} slideToClickedSlide={false}>
        <RoundInfoItem
          key={i}
          infoImage={e.image}
          info={e.title}
          moreInfos={e.text}
          more={more}
          less={less}
          button={e.link}
          contactsLabel={contactsLabel}
          contacts={e.contacts ? e.contacts : null}
          loyalty={e.loyalty_level ? e.loyalty_level : null}
          tier={tier}
          locked_phrase={locked_phrase}
        />
        </SwiperSlide>
      )))
    }
  }, [items]);

  return (
    <div className={styles.roundGrid}>
      <div className={styles.title}>{title}</div>
      {subtitle && <div className={styles.subtitle} dangerouslySetInnerHTML={{ __html: subtitle }} />}
      <div className={styles.gridContent}>
        <Swiper slidesPerView={1}
              spaceBetween={0}
              slideToClickedSlide={true}
              autoplay={true}
              loop={true}
              // loop
              navigation
              breakpoints={{
                780: {
                  slidesPerView: 3
                }
              }}
              // pagination={mobileview}
              >
        {list}
        </Swiper>
      </div>
    </div>
  );
};

export default RoundGrid;
